import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

const QUERY = gql`
  query productsWhatsNew($accountId: String!, $itemClass: String) {
    productsWhatsNew(accountId: $accountId, itemClass: $itemClass) {
      id
      name
      sku
      attributes {
        code
        value
      }
      variants {
        price
        name
        type
        attributes {
          code
          value
        }
      }
      media {
        type
        url
      }
      cartAddable {
        addable
        message
      }
      set
      products {
        id
        name
        sku
        attributes {
          code
          value
        }
        variants {
          price
          name
          type
          attributes {
            code
            value
          }
        }
        cartAddable {
          addable
          message
        }
      }
      inventoryCount
    }
  }
`;

const useProductsWhatsNew = (accountId: string, itemClass?: string) => {
  return useQuery(QUERY, { variables: { accountId, itemClass } });
};

export default useProductsWhatsNew;
